import { useNavigate, useParams } from "react-router-dom";
import { API } from "../../config/api";
import { GET, PUT } from "../../utils/apicalls";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  notification,
  Row,
  Select,
} from "antd";
import { useEffect, useState } from "react";


import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import PageHeader from "../../admin/pageHeader/pageheader";

function UpdatePayrollDetails() {
  const [form] = Form.useForm();
  const { id } = useParams();
  const navigate = useNavigate();
  const [UsersData, setUsersData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState<any>([]);
  const [selectClientData, setselectClientData] = useState<any>([]);

  const onFinish = async (values: any) => {
    try {
      const salaryId = uuidv4();
      let obj = {
        employeeId: values.employeeId,
        salaryId: salaryId,
        ClientId: Number(values.ClientId),
        type: String(values.type),
        date: values.date?.format("YYYY-MM-DD"),
        IN_Amount: Number(values.IN_Amount),
        OUT_Amount: Number(values.OUT_Amount),
        TotalAmount: Number(values.TotalAmount),
        category: values.category,
        method: values.method,
      };

      const api = API.UPDATE_SALARY_DETAILS + id;
      const postRequest = await PUT(api, obj);

      if (postRequest) {
        notification.success({
          message: "Updated successfully",
        });
        navigate(-1);
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error("Error updating data:", error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    }
  };

  useEffect(() => {
    getLeaveData();
  }, []);

  const getLeaveData = async () => {
    try {
      let api = API.GET_ONE_SALARY_DETAILS + id;
      const Data: any = await GET(api, {});
      const leaveData = Data?.data;

      if (!leaveData) {
        setUsersData(null);
      } else {
        leaveData.date = leaveData.date ? moment(leaveData.date) : null;
        setUsersData(leaveData);
        form.setFieldsValue(leaveData);
      }
    } catch (error) {
      console.log("Error fetching user data:", error);
      setUsersData(null);
    }
  };

  const fetchEmployee = async () => {
    try {
      setIsLoading(true);
      const url = API.EMPLOYEE_LISTING;
      const data: any = await GET(url, {});
      setEmployeeData(data?.data || []);
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setEmployeeData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchClient = async () => {
    try {
      setIsLoading(true);
      const url = API.CLIENT_LISTING;
      const { data }: any = await GET(url, null);
      setselectClientData(data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchClient();
    fetchEmployee();
  }, []);

  return (
    <div>
      <PageHeader />
      <Card>
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Row gutter={16}>
            {UsersData?.employeeId && (
              <Col sm={6}>
                <Form.Item label="Employee Name" name="employeeId">
                  <Select placeholder="Select an employee">
                    {employeeData.map((users: any) => (
                      <Select.Option key={users.id} value={users.id}>
                        {users.fullName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}

            {UsersData?.ClientId && (
              <Col sm={6}>
                <Form.Item label="Client Name" name="ClientId">
                  <Select placeholder="Select a client" allowClear>
                    {selectClientData.map((users: any) => (
                      <Select.Option key={users.id} value={users.id}>
                        {users.companyName}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}

            {UsersData?.date && (
              <Col sm={6}>
                <Form.Item name="date" label="Date">
                  <DatePicker format="DD/MM/YYYY" />
                </Form.Item>
              </Col>
            )}

            {UsersData?.IN_Amount && (
              <Col sm={6}>
                <Form.Item name="IN_Amount" label="IN Amount">
                  <Input type="number" placeholder="IN Amount" />
                </Form.Item>
              </Col>
            )}

            {UsersData?.OUT_Amount && (
              <Col sm={6}>
                <Form.Item name="OUT_Amount" label="OUT Amount">
                  <Input type="number" placeholder="OUT Amount" />
                </Form.Item>
              </Col>
            )}

            {UsersData?.category && (
              <Col sm={6}>
                <Form.Item name="category" label="Category">
                  <Select placeholder="Select a category">
                    <Select.Option value="salary">Salary</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            )}

            {UsersData?.type && (
              <Col sm={6}>
                <Form.Item name="type" label="Type">
                  <Select placeholder="Select a type">
                    <Select.Option value="approved">Approved</Select.Option>
                    <Select.Option value="rejected">Rejected</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            )}

            {UsersData?.method && (
              <Col sm={6}>
                <Form.Item name="method" label="Payment Method">
                  <Input placeholder="Enter method" />
                </Form.Item>
              </Col>
            )}
          </Row>

          <Row>
            <Col xs={24} sm={12} md={8}>
              <Button size="large" type="primary" htmlType="submit" block>
                Update
              </Button>
            </Col>
          </Row>
        </Form>
      </Card>
    </div>
  );
}

export default UpdatePayrollDetails;